import AxiosInterceptor from "../utils/AxiosInterceptor"; // http://localhost:5000/api

const normalizeVendorBusinessTypesForBackend = (input) => {
  if (input === undefined) return undefined;

  let parsed = input;

  // Handle string payloads (including accidentally double-stringified JSON)
  if (typeof parsed === "string") {
    try {
      parsed = JSON.parse(parsed);
      if (typeof parsed === "string") {
        parsed = JSON.parse(parsed);
      }
    } catch {
      // If it's not valid JSON, let backend handle/throw its own error
      return input;
    }
  }

  if (!Array.isArray(parsed)) parsed = [parsed];

  const normalized = parsed
    .map((item) => {
      // Preserve category as an object { title, description, image, status }
      const catObj = typeof item.category === "object" ? item.category : {};
      const catTitle = typeof item.category === "string"
        ? item.category
        : (catObj.title || catObj.name || "");

      const category = {
        title: String(catTitle).trim(),
        description: typeof catObj.description === "string" ? catObj.description : "",
        image: typeof catObj.image === "string" ? catObj.image : (typeof item.image === "string" ? item.image : ""),
        status: catObj.status || item.status || "active",
      };

      const subsArray = Array.isArray(item.subcategories)
        ? item.subcategories
        : [];

      // Convert subcategories to array of objects { title, status, description }
      const subcategories = subsArray
        .map((s) => {
          if (typeof s === "object" && s) {
            return {
              title: (s.title || s.name || "").trim(),
              status: s.status || "active",
              description: s.description || "",
            };
          }
          const title = String(s || "").trim();
          return title ? { title, status: "active", description: "" } : null;
        })
        .filter(Boolean);

      return {
        category: category,
        subcategories: subcategories,
      };
    })
    .filter((x) => x.category.title);

  return JSON.stringify(normalized);
};

export const GlobalServices = {
  // Get all global settings in one call
  getAllGlobalSettings: (value) =>
    AxiosInterceptor().get("/admin/globals/getAllGlobalSettings"),

  // Update all global settings in one call
  updateGlobalSettings: (value) => {
    const payload = { ...(value || {}) };

    if (Object.prototype.hasOwnProperty.call(payload, "vendorBusinessTypes")) {
      payload.vendorBusinessTypes = normalizeVendorBusinessTypesForBackend(
        payload.vendorBusinessTypes,
      );
    }

    return AxiosInterceptor().post(
      "/admin/globals/updateGlobalSettings",
      payload,
    );
  },
  
  // Upload specific global image (e.g. for categories)
  uploadGlobalImage: (formData) =>
    AxiosInterceptor().post("/admin/globals/image-uplod", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  getPetQuiz: () => AxiosInterceptor().get("/admin/globals/getPetQuiz"),
  getFaqCategory: () => AxiosInterceptor().get("/admin/globals/getFaqCategory"),
};
